// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

export const jiraBusinessBoardResources = (): RouteResource[] => [
	...getNavigationResources(),
	projectThemeResource,
	// delete when cleaning up standalone-filter-refinement-sprt
	resourceWithCondition(
		() => !expVal('standalone-filter-refinement-sprt', 'isEnabled', false),
		fieldsResource,
	),
];
